var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{attrs:{"fluid":""}},[_c('b-row',[_c('b-col',{staticClass:"mb-1 p-0"},[_c('bilet-description')],1)],1),_c('b-row',[_c('b-col',{staticClass:"mt-0 p-0"},[_c('bilet-footer')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }